export class User {
  userId?: number;
  id?: number;
  title?: string;
  firstName: string;
  lastName: string;
  email: string;
  password?: any;
  mobileNumber: any;
  address: string;
  address1: string;
  zipCode: number;
  // stateId: number;
  city?: string;
  cityName?: string;
  countryId: number;
  reviewers?;
  approvers?;
  signatureUrl?;
}
